const API_BASE =
  window.location.hostname === "localhost"
    ? "http://localhost/jyotish_karmaa_api"
    : "https://visnology.com/api";

export default API_BASE;
